import React, { createContext, useContext, useState } from "react";
import { ILoadingContext } from "../exports/interfaces";

const LoaderContext = createContext<ILoadingContext>({
  loading: true,
  setLoading: () => null,
});
export const useLoader = () => useContext(LoaderContext);

export const LoaderProvider = ({ children }: { children: React.ReactNode }) => {
  const [loading, setLoading] = useState<boolean>(true);

  return (
    <LoaderContext.Provider value={{ loading, setLoading }}>
      {children}
    </LoaderContext.Provider>
  );
};
